module.exports = __webpack_public_path__ + "static/virtual-tour-97202bae8c8b92f061c51c55cc5644bd.webp";